module.exports = __webpack_public_path__ + "img/rechargeSuccess.2a8fed90.png";